module.exports = __webpack_public_path__ + "officialStatic/img/schoolBg.b6eddbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/schoolBg.jpg
// module id = eCbL
// module chunks = 0